import { memo, useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { HotelTemplateType, type HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";

import { StepHeader } from "../_step-header";

type Props = {
	hotelTemplateSettings: HotelTopQuery["hotelTemplateSettings"];
};

export const NavigateSelectHotelTemplatePage = memo(({ hotelTemplateSettings }: Props) => {
	const navigate = useNavigate();
	const navigateToSelectHotelTemplatePage = useCallback(() => {
		navigate(generatePath(PATHS.HOTEL.SELECT_HOTEL_TEMPLATE, { hotelID: hotelTemplateSettings.hotelID }));
	}, [hotelTemplateSettings.hotelID, navigate]);

	const handleResetButtonClick = useCallback(() => {
		navigateToSelectHotelTemplatePage();
	}, [navigateToSelectHotelTemplatePage]);

	if (
		!(
			hotelTemplateSettings.hotelTemplateTypeSelectable &&
			hotelTemplateSettings.hotelTemplateType === HotelTemplateType.NotSelected
		)
	) {
		// (テンプレート選択ができる & テンプレート未選択 ) の条件を満たしていない場合は表示しない
		return null;
	}

	return (
		<div className="space-y-4">
			<div className="space-y-2">
				<StepHeader title="" description="ホテルテンプレートを選択する" />
				<p>
					ホテルテンプレートを選択することで、 プラン・部屋・オプションのデータが自動で作成されます。
					<br />
					自動作成後は、料金や在庫、画像などを設定することで簡単に販売を開始できます。
				</p>
			</div>

			<Button variant="outline" onClick={handleResetButtonClick}>
				ホテルテンプレートを選択する
			</Button>
		</div>
	);
});

NavigateSelectHotelTemplatePage.displayName = "NavigateSelectHotelTemplatePage";
